import { render, staticRenderFns } from "./send-receipt.vue?vue&type=template&id=2bbb1b27&scoped=true"
import script from "./send-receipt.vue?vue&type=script&lang=js"
export * from "./send-receipt.vue?vue&type=script&lang=js"
import style0 from "./send-receipt.vue?vue&type=style&index=0&id=2bbb1b27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb1b27",
  null
  
)

export default component.exports